import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { BaseSettingsSectionComponent } from "../base-settings-section.component";
import { ExtensionSettingsService } from "../extension-settings.service";

@Component({
    selector: "app-flyrewrite-settings",
    templateUrl: "./flyrewrite-settings.component.html",
    styleUrls: ["./flyrewrite-settings.component.scss"],
    standalone: false
})
export class FlyrewriteSettingsComponent extends BaseSettingsSectionComponent implements OnInit, OnChanges {
  @Input() initialEnabled = true;

  private lastSavedEnabled: boolean;

  constructor(
    private readonly fb: FormBuilder,
    private readonly settingsService: ExtensionSettingsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.lastSavedEnabled = this.initialEnabled;
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialEnabled && !changes.initialEnabled.firstChange) {
      this.lastSavedEnabled = changes.initialEnabled.currentValue;
      if (this.form) {
        this.form.patchValue({ flyRewrite: this.lastSavedEnabled }, { emitEvent: false });
        this.markPristine();
      }
    }
  }

  buildForm(): FormGroup {
    return this.fb.group({
      flyRewrite: [this.initialEnabled],
    });
  }

  getSaveObservable(): Observable<any> {
    const { flyRewrite } = this.form.value;
    this.lastSavedEnabled = flyRewrite;
    return this.settingsService.saveFlyRewrite(flyRewrite);
  }

  resetToLastSaved(): void {
    this.form.patchValue({ flyRewrite: this.lastSavedEnabled }, { emitEvent: false });
  }

  get flyRewriteEnabled(): boolean {
    return this.form?.get("flyRewrite")?.value;
  }
}
